export class YoutubeException extends Error {}
